import { AlertTab } from "model/state";

export type RouteParams = {
  currentTab: AlertTab,
}

export function getRoute(params: RouteParams): string {
  return `/alerts${params.currentTab === 'all' ? '' : `/${params.currentTab}`}`;
}
